import React, { useRef, useEffect } from 'react';
import { Link, NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar: React.FC = () => {
  const socialsRef = useRef<HTMLLIElement>(null);
  const contentRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const updateDropdownPosition = () => {
      if (socialsRef.current && contentRef.current) {
        const rect = socialsRef.current.getBoundingClientRect();
        contentRef.current.style.top = `${rect.bottom}px`;
        contentRef.current.style.left = `${rect.left}px`;
      }
    };
    
    // Set position on mount and when window resizes
    updateDropdownPosition();
    window.addEventListener('resize', updateDropdownPosition);
    
    // Set position when socials link is hovered
    const socialsElement = socialsRef.current;
    if (socialsElement) {
      socialsElement.addEventListener('mouseenter', updateDropdownPosition);
    }
    
    return () => {
      window.removeEventListener('resize', updateDropdownPosition);
      if (socialsElement) {
        socialsElement.removeEventListener('mouseenter', updateDropdownPosition);
      }
    };
  }, []);
  
  return (
    <header className="fixed-top">
      <nav className="navbar navbar-light bg-white" style={{ '--bs-bg-opacity': .95 } as React.CSSProperties} aria-label="Main Navigation">
        <div className="container">
          <h1>
            <NavLink to="/" className="navbar-brand p-1" end>Wyeth Thompson</NavLink>
          </h1>
          <ul className="navbar-nav ms-auto d-flex flex-row">
            <li className="nav-item">
              <NavLink to="/work" className="nav-link mx-1">Experience</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/portfolio" className="nav-link mx-1">Portfolio</NavLink>
            </li>
            <li className="nav-item">
              <NavLink to="/photography" className="nav-link mx-1">Photography</NavLink>
            </li>
            <li className="nav-item socials-dropdown" ref={socialsRef}>
              <span className="nav-link mx-1">Socials</span>
              <div className="socials-content" ref={contentRef}>
                <a 
                  href="https://www.linkedin.com/in/wyeth-thompson/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  LinkedIn <img src='/assets/linkedin-logo.png' alt="LinkedIn" className="social-icon" />
                </a>
                <a 
                  href="https://github.com/wyeth-t" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  GitHub
                </a>
                <a 
                  href="mailto:wyeththompson@gmail.com"
                >
                  Email
                </a>
                <a 
                  href="https://www.instagram.com/wyetht/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Instagram
                </a>
              </div>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default Navbar;
